/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable radix */
import { useCallback, useState } from 'react'
import Dropzone from 'react-dropzone'
import { uniqueId } from 'lodash'
import filesize from 'filesize'
import { RiUploadFill } from 'react-icons/ri'
import { useTranslation } from 'react-i18next'
import {
  Container,
  DropzoneStyle,
  ContentLeft,
  ContentDropzone
} from './styles'
import { useDocument } from '../../../hooks/useDocument'

interface Images {
  file: File
  id: string
  name: string
  readbleSize: string
  preview: string
  progress: number
  uploaded: boolean
  error: boolean
  url: string | null
}

type ImagesData = Array<Images>

interface DropZoneProps {
  onImageSelected?: (base64Image: string, preview: string, file: File) => void
}

const DropZone = ({ onImageSelected }: DropZoneProps) => {
  const { t } = useTranslation('global')
  const { setImgSrc, setImgFile } = useDocument()
  const [imgUp, setImgUp] = useState<ImagesData>([])
  const [loading, setLoading] = useState(false)

  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result as string)
      reader.onerror = (error) => reject(error)
    })
  }

  const handleUpload = async (files: File[]) => {
    setLoading(true)
    const propsUploaded = files.map((file: File) => ({
      file,
      id: uniqueId(),
      name: file.name,
      readbleSize: filesize(file.size),
      preview: URL.createObjectURL(file),
      progress: 0,
      uploaded: false,
      error: false,
      url: null
    }))

    setImgUp(propsUploaded)

    try {
      const selectedImage = propsUploaded[0]

      if (!selectedImage?.file) return

      const base64String = await fileToBase64(selectedImage.file)

      setImgSrc(selectedImage.preview)
      setImgFile(base64String)
      onImageSelected?.(base64String, selectedImage.preview, selectedImage.file)
    } catch (error) {
      console.error('Error converting file to base64:', error)
    } finally {
      setLoading(false)
    }
  }

  const renderDragMessage = useCallback((isDragActive, isDragReject) => {
    if (!isDragActive) {
      return (
        <ContentLeft>
          <div>
            <RiUploadFill size={48} color="#e6e6e6" />
            <h4>{t('dropzoneLabel')}</h4>
          </div>
        </ContentLeft>
      )
    }

    if (isDragReject) {
      return (
        <ContentDropzone type="error">
          <h1>Arquivo não suportado</h1>
        </ContentDropzone>
      )
    }

    return (
      <ContentDropzone type="sucess">
        <h1>Solte os arquivos aqui</h1>
      </ContentDropzone>
    )
  }, [])

  return (
    <Dropzone
      accept="image/*"
      onDropAccepted={(files) => handleUpload(files)}
    >
      {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
        <Container {...getRootProps()}>
          <DropzoneStyle>
            {' '}
            {/*  todas as propriedades de upload */}
            <input {...getInputProps()} />
            <>
              {loading ? (
                <ContentLeft>
                  <p>Carregando...</p>
                </ContentLeft>
              ) : (
                <>
                  {imgUp.length > 0 ? (
                    <div style={{ width: `100%`, height: `100%` }}>
                      <img src={imgUp[0]?.preview} alt="flag" />
                    </div>
                  ) : (
                    <>{renderDragMessage(isDragActive, isDragReject)}</>
                  )}
                </>
              )}
            </>
          </DropzoneStyle>
        </Container>
      )}
    </Dropzone>
  )
}

export default DropZone
